export default __webpack_public_path__ + "static/media/startup.837d32ec.png";